if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        if (!window.Tabs) return;

        this.list = this.querySelector('[role="tablist"]');
        this.instance = new window.Tabs(this, { hash: false });
        this.instance.init();
        this.disclosures = [];

        this.instance.tabs.forEach((tab) => {
          // Tabs focuses the tab right after this event, which scrolls it into
          // view instantly. Waiting a frame lets our smooth scroll win.
          tab.el.addEventListener('Tab.activate', () => {
            requestAnimationFrame(() => this.scrollTabIntoView(tab.el));
          });
        });

        this.initDisclosures();
      }

      disconnectedCallback() {
        if (this.instance) this.instance.destroy();
        this.disclosures.forEach((disclosure) => disclosure.destroy());
        this.disclosures = [];
      }

      initDisclosures() {
        const DisclosureButton = window.DisclosureButton?.default || window.DisclosureButton;
        if (!DisclosureButton) return;

        this.querySelectorAll('[data-disclosure-button]').forEach((button) => {
          const disclosure = new DisclosureButton(button);
          disclosure.init();
          this.disclosures.push(disclosure);
        });
      }

      scrollTabIntoView(element) {
        if (this.list.scrollWidth <= this.list.clientWidth) return;
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  );
}
